import { render, staticRenderFns } from "./UpdateProcesses.vue?vue&type=template&id=5f9cdf5b"
import script from "./UpdateProcesses.vue?vue&type=script&lang=js"
export * from "./UpdateProcesses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports